/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query VendorAccounttDirectoryReadUniqueQuery($vendorAccounttDirectoryId: ID!) {
  VendorAccounttDirectoryReadUnique(vendorAccounttDirectoryId: $vendorAccounttDirectoryId) {
    id,
    displayName,
    message,
    status
  }
}
`
